import React from "react";
import { SmartTableNewInterface } from "soft_digi";
import { CONSUMPTION_URL } from "../../api/UserUrls";
import ImportExcelLayout from "../../components/site/ImportExcelLayout";

interface HeaderProps {
  loadTableData: () => void;
}

const ImportReportTable: React.FC<HeaderProps> = ({ loadTableData }) => {
  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "Hub", index: "hub_name", width: "15" },
    { title: "Customer", index: "vendor", width: "15" },
    { title: "Date", index: "date", width: "15" },
    { title: "Units", index: "count", width: "15" },
    {
      title: "Status",
      index: "status",
      width: "15",
      type: "tags",
      tags: [
        { value: 5, label: "Success", class: "is-success" },
        { value: 10, label: "Error", class: "is-danger" },
      ],
    },
    { title: "Remarks", index: "msg", width: "15" },
  ];

  return (
    <ImportExcelLayout
      loadTableData={loadTableData}
      uploadUrl={CONSUMPTION_URL.IMPORT_EXCEL}
      templateHeaders={["S.NO", "Hub", "Customer", "Date", "Units"]}
      templateSampleData={[
        ["1", "Hub01", "Customer A", "01-01-2024", "100"],
        ["2", "Hub02", "Customer B", "02-01-2024", "200"],
      ]}
      templateFileName="consumption_report_template.xlsx"
      description="Download the template, fill in your consumption report data, and upload it below."
      columns={columns}
    />
  );
};

export default ImportReportTable;
